import { sourceContext } from "aurelia-binding";

export class DirtyBindingBehavior {

	bind(binding, source, frequency = 500) {
		if (!binding.updateTarget) {
			throw new Error("Only property bindings and string interpolation bindings can be dirty checked. Trigger, delegate and call bindings cannot be dirty checked.");
		}

		if (frequency) {
			binding.dirtyTimer = setInterval(() => binding.call(sourceContext), frequency);
		}
	}

	unbind(binding) {
		if (binding.dirtyTimer) {
			clearInterval(binding.dirtyTimer);
		}
	}
}
